import React from "react";

export default function BusinessDeliveryPrices() {
  return <div>BusinessDeliveryPrices</div>;
}
